import commonApi from './CommonApi.js';

export default {
    newItem: async (parameters) => {
        return await commonApi().get('/let-document-notification/new', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAll: async (parameters) => {
        return await commonApi().get('/let-document-notification/getAll', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getById: async (parameters) => {
        return await commonApi().get('/let-document-notification/getById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    create: async (viewModel) => {
        return await commonApi().post('/let-document-notification', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    edit: async (viewModel) => {
        return await commonApi().put('/let-document-notification', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    delete: async (parameters) => {
        return await commonApi().delete('/let-document-notification', { params: parameters })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getDelegations: async (parameters) => {
        return await commonApi().get('/let-document-notification/getDelegations', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    generate: async (parameters) => {
        return await commonApi().get('/let-document-notification/generate', { params: parameters, responseType: 'blob' })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getActive: async (parameters) => {
        return await commonApi().get('/let-document-notification/getActive', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAutocomplete: async (parameters) => {
        return await commonApi().get('/let-document-notification/getAutocomplete', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getBySymbol: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-by-symbol', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },

    getProposedModificationCoverage: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-coverage', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getProposedModificationPartyCoverage: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-party-coverage', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getProposedModificationEntities: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-entities', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },

    getProposedModificationNotes: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-notes', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },

    getProposedModificationGoods: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-goods', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },
    getProposedModificationServices: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-services', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },
    getProposedModificationConstructionServices: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-proposed-modification-construction-services', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },
    saveProposedModificationCoverage: async (viewModel) => {
        return await commonApi().post('/let-document-notification/saveProposedModificationCoverage', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    },
    savePublicationMediaCoverage: async (viewModel) => {
        return await commonApi().post('/let-document-notification/savePublicationMediaCoverage', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    },
    getPublicationMediaCoverage: async (parameters) => {
        return await commonApi().get('/let-document-notification/getPublicationMediaCoverage', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },
    getPublicationMediaItems: async (parameters) => {
        return await commonApi().get('/let-document-notification/getPublicationMediaItems', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
                console.log(error.response);
            });
    },

    getPublicationMediaPartyCoverage: async (parameters) => {
        return await commonApi().get('/let-document-notification/get-publication-media-party-coverage', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
}
